/* eslint-disable no-new */
export default {
    setIssues({ commit }, val) {
        commit('SET_ISSUES', val);
    }
};
